<template>
  <div class="indexbodyitem">
    <div class="row" v-if="this.layout == 'waterfall'">
      <div
        :class="[
          { 'col-sm-8 item': products.length == 3 },
          { 'col-sm-6 item': products.length == 2 },
          { 'col-12 item': products.length == 1 },
        ]"
      >
        <v-commoditylistitemcard
          :productDetail="products[0]"
          :classtype="products.length == 2 ? 'thumbnail' : 'bigphoto'"
          imgsize="auto"
          :custom_button="
            is_custom_button &&
            ((products[0] && products[0].custom_button && products[0].custom_button.custom_button) ||
              (mix_custom_button_list &&
                mix_custom_button_list[products[0]['ID']] &&
                mix_custom_button_list[products[0]['ID']].custom_button))
          "
          :palette_config="palette_config"
          :isShowMainImg="true"
        ></v-commoditylistitemcard>
      </div>
      <div
        v-if="products.length > 1"
        :class="[
          { 'col-sm-4': products.length == 3 },
          { 'col-sm-6': products.length == 2 },
          { 'order-first': index % 2 == 0 },
        ]"
      >
        <div v-if="products[1]" class="item">
          <v-commoditylistitemcard
            :productDetail="products[1]"
            classtype="thumbnail"
            imgsize="auto"
            :palette_config="palette_config"
            :custom_button="
              is_custom_button &&
              ((products[1] && products[1].custom_button && products[1].custom_button.custom_button) ||
                (mix_custom_button_list &&
                  mix_custom_button_list[products[1]['ID']] &&
                  mix_custom_button_list[products[1]['ID']].custom_button))
            "
            :isShowMainImg="true"
          ></v-commoditylistitemcard>
        </div>
        <div v-if="products[2]" class="item">
          <v-commoditylistitemcard
            :productDetail="products[2]"
            classtype="thumbnail"
            imgsize="auto"
            :palette_config="palette_config"
            :custom_button="
              is_custom_button &&
              ((products[2] && products[2].custom_button && products[2].custom_button.custom_button) ||
                (mix_custom_button_list &&
                  mix_custom_button_list[products[2]['ID']] &&
                  mix_custom_button_list[products[2]['ID']].custom_button))
            "
            :isShowMainImg="true"
          ></v-commoditylistitemcard>
        </div>
      </div>
    </div>
    <div class="row" v-else>
      <div v-for="item in products" :key="item.ID" class="col-sm-4 item">
        <v-commoditylistitemcard
          :productDetail="item"
          classtype="thumbnail"
          imgsize="(max-width: 358px) 189px,
            (max-width: 576px) 295px,
            (max-width: 768px) 135px,
            (max-width: 992px) 189px,
             215px"
          :palette_config="palette_config"
          :custom_button="
            is_custom_button &&
            ((item && item.custom_button && item.custom_button.custom_button) ||
              (mix_custom_button_list &&
                mix_custom_button_list[item['ID']] &&
                mix_custom_button_list[item['ID']].custom_button))
          "
          :isShowMainImg="true"
        ></v-commoditylistitemcard>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'

export default {
  props: ['products', 'index', 'layout', 'collectionsslug', 'is_custom_button', 'custom_button', 'palette_config'],
  computed: {
    ...mapState({
      mix_custom_button_list: (state) => {
        return state.custom_button_list
      },
    }),
  },
}
</script>
<style scoped lang='scss'>
.indexbodyitem {
  margin-top: 20px;

  .row {
    .item {
      position: relative;

      .thumbnail {
        min-height: 255px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f9f1e6;
        padding: 20px 0;
        margin: 0;
        overflow: hidden;
        position: relative;
        img {
          max-width: 90%;
          max-height: 215px;
        }
        &:hover {
          opacity: 0.9;
        }
      }
      .bigphoto {
        min-height: 580px;
        padding: 20px 0;
        background: #f9f1e6;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;

        img {
          max-width: 90%;
          max-height: 540px;
          &:hover {
            opacity: 0.9;
          }
        }
        // &:hover {
        //   transition: opacity 0.15s ease-in;
        //   opacity: 0.9;
        // }
      }

      a {
        border: none;
      }

      .intro {
        display: block;
        text-decoration: none;
        text-align: center;
        color: black;
        font-size: 1.2em;
        padding-top: 13px;
        margin-bottom: 15px;
        padding-bottom: 15px;
        p {
          margin: 0;
          // display: inline-block;
          span {
            font-size: 14px;
            color: black;
            font-weight: 600;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .indexbodyitem {
    .row {
      .thumbnail {
        min-height: 165px !important;

        img {
          max-height: 205px !important;
        }
      }

      .bigphoto {
        min-height: 480px !important;

        img {
          max-height: 440px !important;
        }
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .indexbodyitem {
    .row {
      .thumbnail {
        min-height: 115px !important;

        img {
          max-height: 155px !important;
        }
      }

      .bigphoto {
        min-height: 440px !important;

        img {
          max-height: 400px !important;
        }
      }
    }
  }
}

@media screen and (max-width: 575px) {
  .indexbodyitem {
    .row {
      .thumbnail {
        min-height: 335px !important;
        height: 335px !important;

        img {
          max-height: 295px !important;
        }
      }

      .bigphoto {
        min-height: 335px !important;
        height: 335px !important;

        img {
          max-height: 295px !important;
        }
      }
    }
  }
}
</style>